module.exports = __webpack_public_path__ + "static/media/googlePin12.eb5d5109.svg";